// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"4f59f2a2","156":"097d0179","341":"d04918e4","438":"39bbd81a","706":"04cce049","726":"0cfacddc"}[chunkId] + ".chunk.js";
};